import { ChangeEvent, FC, KeyboardEvent, ReactElement, RefObject, useCallback, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'

import { useI18n } from '../../hooks'

import './index.css'

type SearchBarProps = {
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void
  searchQuery: string
  inputRef: RefObject<HTMLInputElement>
  toggleSearchbar: React.Dispatch<React.SetStateAction<boolean>>
}

const SearchBar: FC<SearchBarProps> = ({ onInputChange, searchQuery, inputRef, toggleSearchbar }): ReactElement => {
  useEffect(() => {
    inputRef.current?.focus()
  }, [inputRef])
  const { t } = useI18n()
  const history = useHistory()
  const handleKeyup = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        toggleSearchbar(false)
        return searchQuery && history.push(`/shop?search=${encodeURIComponent(searchQuery)}`)
      }
    },
    [history, searchQuery, toggleSearchbar]
  )
  const searchButton = useCallback(
    () =>
      searchQuery ? (
        <Link to={`/shop?search=${encodeURIComponent(searchQuery)}`}>
          <button className="search-button" onClick={() => toggleSearchbar(false)}>
            {t('Common_search')}
          </button>
        </Link>
      ) : (
        <button className="search-button" disabled>
          {t('Common_search')}
        </button>
      ),
    [searchQuery, t, toggleSearchbar]
  )

  return (
    <div className="search-model-container fade-in">
      <label htmlFor="searchbar-input" className="search-inputlabel">
        {t('Common_imLookingFor')}
      </label>
      <input
        id="searchbar-input"
        ref={inputRef}
        className="search-input"
        onChange={onInputChange}
        value={searchQuery}
        onKeyUp={handleKeyup}
      />
      {searchButton()}
    </div>
  )
}

export default SearchBar
